import { ApolloClient, gql, NormalizedCacheObject, QueryHookOptions, useQuery } from '@apollo/client'
import { GetMyTestedListQuery, GetMyTestedListQueryVariables } from 'types/graphql'
import { brandRowFieldsFragment } from 'modules/brands/list/queries/getDiscoveryBrands'

const getUnreviewedTestedBrandsQuery = gql`
  query GetMyTestedList($take: Int, $skip: Int, $includeDismissed: Boolean) {
    list(type: Tested) {
      id
      type
      brands(isReviewed: false, take: $take, skip: $skip, includeDismissed: $includeDismissed) {
        total
        hasMore
        nextSkip
        items {
          ...BrandRowFields
        }
      }
    }
  }
  ${brandRowFieldsFragment}
`

export const queryMyUnreviewedTestedBrands = ({
  apolloClient,
  variables
}: {
  apolloClient: ApolloClient<NormalizedCacheObject>
  variables: GetMyTestedListQueryVariables
}) => {
  return apolloClient.query<GetMyTestedListQuery, GetMyTestedListQueryVariables>({
    query: getUnreviewedTestedBrandsQuery,
    variables
  })
}

export const useMyUnreviewedTestedBrands = (options?: QueryHookOptions<GetMyTestedListQuery, GetMyTestedListQueryVariables>) => {
  return useQuery<GetMyTestedListQuery>(getUnreviewedTestedBrandsQuery, options)
}
